import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const CategoryContractor = () => {
  return (
    <SettingsMetaData propertyName={"Category_Contractor"} viewPropertyName={"Category"} />
  );
};
export default CategoryContractor;